import { createRouter, createWebHistory } from 'vue-router'
import Index from '../views/Index.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/index',
    name: 'index_pc',
    component: () => import('../views/other/Index_pc.vue')
  },
  {
    path: '/note/:id',
    name: 'note',
    component: () => import('../views/share/Note_detail.vue')
  },
  {
    path: '/wcard/:id',
    name: 'word_card',
    component: () => import('../views/share/Word_card.vue')
  },
  {
    path: '/ccard/:id',
    name: 'zici_card',
    component: () => import('../views/share/Zici_card.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/other/Agreement.vue')
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: () => import('../views/other/DownLoads.vue')
  },
  {
    path: '/ball_test',
    name: 'Ball_test',
    component: () => import('../views/share/Ball_test.vue')
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: () => import('../views/other/404.vue')
  }
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes
})

export default router
